import type { ProductWithoutPreviewFilter as FilterType } from '@@partner:graphql/query/product/productWithoutPreview'

import React from 'react'
import { compose, map, pathOr } from 'rambda'
import { useFetchProductAvailableCategories } from '@@partner:graphql/query/catalog/productAvailableCategories.gql'

import {
  Container,
  FlexboxGrid,
  Input,
  Button,
  SelectPicker,
  ButtonGroup,
} from 'rsuite'

export const DEFAULT_PRODUCT_WITHOUT_PREVIEW_FILTER: FilterType = {
  name: '',
  xid: '',
  categoryId: null,
  afterId: null,
}

interface ProductWithoutPreviewFilterProps {
  filter: FilterType
  onUpdateFilter?: (name: string, value: string) => void
  onResetFilterClick?: () => void
}

const ProductWithoutPreviewFilter: React.FC<ProductWithoutPreviewFilterProps> = ({
  filter = DEFAULT_PRODUCT_WITHOUT_PREVIEW_FILTER,
  onUpdateFilter,
  onResetFilterClick,
}) => {
  const { data: categoriesData, loading: categoriesLoading = false } = useFetchProductAvailableCategories()

  const categories = compose(
    map((item) => ({ label: item.name, value: item.id })),
    pathOr([], [ 'availableCategories' ])
  )(categoriesData)

  return (
    <Container>
      <FlexboxGrid fluid justify="space-between">
        <FlexboxGrid.Item colspan={6}>
          <Input
            placeholder="Штрихкод"
            onChange={value => onUpdateFilter?.('xid', value)}
            value={filter.xid}
          />
        </FlexboxGrid.Item>
        <FlexboxGrid.Item colspan={6}>
          <Input
            placeholder="Название"
            onChange={value => onUpdateFilter?.('name', value)}
            value={filter.name}
          />
        </FlexboxGrid.Item>
        <FlexboxGrid.Item colspan={6}>
          <SelectPicker
            block
            placeholder="Категория"
            loading={categoriesLoading}
            data={categories}
            onChange={value => onUpdateFilter?.('categoryId', value)}
            value={filter.categoryId}
          />
        </FlexboxGrid.Item>
        <FlexboxGrid.Item colspan={4}>
          <ButtonGroup>
            <Button color="red" onClick={onResetFilterClick}>
              Сброс
            </Button>
          </ButtonGroup>
        </FlexboxGrid.Item>
      </FlexboxGrid>
    </Container>
  )
}

export default ProductWithoutPreviewFilter